const BetCard = ({ data }) => {
  const DATE = data?.date
  const TIME = data?.time
  const SUB_TYPE = data?.subType
  const STAKE = data?.stake
  const PAYOUT_MULTIPLIER = data?.payoutMultiplier
  const PAYOUT = data.payout
  const RESULT = data.result

  return (
    <div className="standard-normal-bet-card-outer-container">
      <div className="standard-normal-bet-card-inner-container">
        <div className="standard-normal-bet-card-element">
          <div className="standard-normal-bet-card-element-date">{DATE}</div>
          <div className="standard-normal-bet-card-element-time">{TIME}</div>
        </div>
        <div className="standard-normal-bet-card-element">
          <div className="standard-normal-bet-card-element-subType">{SUB_TYPE}</div>
        </div>
        <div className="standard-normal-bet-card-element">
          <div className="standard-normal-bet-card-element-stake">{STAKE}</div>
        </div>
        <div className="standard-normal-bet-card-element">
          <div
            className={`standard-normal-bet-card-element-payout-multiplier ${RESULT === 'WON' ? 'won' : 'lost'}`}
          >
            {PAYOUT_MULTIPLIER}
          </div>
        </div>
        <div className="standard-normal-bet-card-element">
          <div
            className={`standard-normal-bet-card-element-payout ${RESULT === 'WON' ? 'won' : 'lost'}`}
          >
            {PAYOUT}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BetCard
